import { createSlice } from '@reduxjs/toolkit';
import {
  getAllBicycles,
  getBicyclesByType,
  getAllUser,
  getUsers,
  getCompanies,
  getSections,
  getNews,
  getNew,
  getCompany,
  getSection,
  getUser
} from './apis/listBicycles';

const initialState = {
  toggled: false,
  session: {
    name: '',
    companyId: undefined,
    companyName: undefined,
    avatar: undefined,
    rol: undefined
  },
  value: 0,
  status: 'idle',
  bicycles: [],
  users: [],
  usersList: [],
  companies: [],
  sections: [],
  news: [],
  new: undefined,
  section: undefined,
  company: undefined,
  user: undefined,
  bicyclesByType: [],
  username: '',
  content: '',
  url: '',
  type: undefined,
  days: 0,
  amountRent: undefined,
  name: undefined,
  points: undefined,
  image: undefined,
  logo: undefined,
  file: undefined,
  avatar: undefined,
  stepsCompleted: {
    username: true,
    type: false,
    days: false,
    amountRent: false,
    image: false
  },
  history: []
};

export const shopBicycleDataSlice = createSlice({
  name: 'shopBicycleData',
  initialState,
  reducers: {
    setToggled: (state) => {
      state.toggled = !state.toggled;
    },
    stepCompleted(state, { payload: { stepsCompleted, name } }) {
      state[stepsCompleted][name] = true;
    },
    updateValueInput(state, { payload: { key, val, child } }) {
      if (child) {
        state[key][child] = val.target.checked;
      } else {
        state[key] = val.target.value;
      }
    },
    updateImage(state, { payload: { key, val } }) {
      state[key] = val;
    },
    updateAmount(state, { payload: { key, val, name } }) {
      const daysSelected = Number(state.days);
      const priceBase = parseFloat(val);
      switch (state.type) {
        case 'electrics':
          state.amountRent = daysSelected * priceBase;
          state.points = 2;
          break;
        case 'old':
          if (daysSelected <= 5) {
            state.amountRent = priceBase;
          } else {
            const daysAfterFiveDays = daysSelected - 5;
            state.amountRent = daysAfterFiveDays * priceBase + priceBase;
          }
          state.points = 1;
          break;
        case 'normal':
          if (daysSelected <= 3) {
            state.amountRent = priceBase;
          } else {
            const daysAfterThreeDays = daysSelected - 3;
            state.amountRent = daysAfterThreeDays * priceBase + priceBase;
          }
          state.points = 1;
          break;
        default:
          break;
      }
      state.name = name;
    },
    updateHistory(state) {
      state.history.push({
        days: Number(state.days),
        type: state.type,
        username: state.username,
        amountRent: state.amountRent,
        name: state.name,
        points: state.points
      });
    },
    clearFields: (state) => {
      state.file = undefined;
      state.username = '';
      state.content = '';
      state.url = '';
      state.file = undefined;
      state.name = '';
    },
    handleField: (state, { payload: { value } }) => {
      state.session.name = value;
    },
    handleFieldCompany: (state, { payload: { value } }) => {
      state.session.companyId = value;
    },
    handleFieldCompanyName: (state, { payload: { value } }) => {
      state.session.companyName = value;
    },
    handleFieldAvatar: (state, { payload: { value } }) => {
      state.session.avatar = value;
    },
    handleFieldRol: (state, { payload: { value } }) => {
      state.session.rol = value;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBicycles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllBicycles.fulfilled, (state, action) => {
        state.bicycles = action.payload;
        state.status = 'idle';
      })
      .addCase(getBicyclesByType.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(getBicyclesByType.fulfilled, (state, action) => {
        state.bicycles = action.payload;
      })
      .addCase(getAllUser.pending, (state) => {
        state.status = 'loading';
      })

      .addCase(getAllUser.fulfilled, (state, action) => {
        state.users = action.payload;
        state.status = 'idle';
      })
      .addCase(getUsers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.usersList = action.payload;
        state.status = 'idle';
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.companies = action.payload;
        state.status = 'loading';
      })
      .addCase(getSections.fulfilled, (state, action) => {
        state.sections = action.payload;
        state.status = 'loading';
      })
      .addCase(getNews.fulfilled, (state, action) => {
        state.news = action.payload;
        state.status = 'loading';
      })
      .addCase(getNew.fulfilled, (state, action) => {
        state.new = action.payload;
        state.status = 'loading';
      })
      .addCase(getCompany.fulfilled, (state, action) => {
        state.company = action.payload;
        state.status = 'loading';
      })
      .addCase(getSection.fulfilled, (state, action) => {
        state.section = action.payload;
        state.status = 'loading';
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.status = 'loading';
      });
  }
});

export const {
  setToggled,
  updateValueInput,
  updateImage,
  updateAmount,
  updateHistory,
  stepCompleted,
  clearFields,
  handleField,
  handleFieldCompany,
  handleFieldCompanyName,
  handleFieldAvatar,
  handleFieldRol
} = shopBicycleDataSlice.actions;

export const selectToggled = (state) => state.shopBicycleData.toggled;
export const selectBicycles = (state) => state.shopBicycleData.bicycles;
export const selectUsers = (state) => state.shopBicycleData.users;
export const selectUserList = (state) => state.shopBicycleData.usersList;
export const selectCompanies = (state) => state.shopBicycleData.companies;
export const selectSections = (state) => state.shopBicycleData.sections;
export const selectNews = (state) => state.shopBicycleData.news;
export const selectNew = (state) => state.shopBicycleData.new;
export const selectCompany = (state) => state.shopBicycleData.company;
export const selectSection = (state) => state.shopBicycleData.section;
export const selectUser = (state) => state.shopBicycleData.user;
export const selectName = (state) => state.shopBicycleData.username;
export const selectContent = (state) => state.shopBicycleData.content;
export const selectUrl = (state) => state.shopBicycleData.url;

export const selectType = (state) => state.shopBicycleData.type;
export const selectDaysRent = (state) => state.shopBicycleData.days;
export const selectStepsCompleted = (state) =>
  state.shopBicycleData.stepsCompleted;
export const selectResume = (state) => state.shopBicycleData;
export const selectImage = (state) => state.shopBicycleData.image;
export const selectLogo = (state) => state.shopBicycleData.logo;
export const selectFile = (state) => state.shopBicycleData.file;
export const selectAvatar = (state) => state.shopBicycleData.avatar;
export const selectAmountRent = (state) => state.shopBicycleData.amountRent;
export const selectHistory = (state) => state.shopBicycleData.history;
export const selectSession = (state) => state.shopBicycleData.session;
export default shopBicycleDataSlice.reducer;
